/**
 * 品牌与站点默认值。
 *
 * 这里是「没有任何配置时」的兜底：官网、登录 / 注册页从这里取名字和热线。
 * 运营在运营后台配了站点信息（名称 / 热线 / 备案号 / 隐私政策 / 统计）后，访客面以配置为准，
 * 这里的值只在配置缺失或接口不可达时露出。控制台壳子左上角固定用 BRAND_NAME，不读站点配置。
 *
 * 品牌名「育蒙语音 Agent」是老板 2026-09-25 拍的板；「电话数字员工」是品类词，不是品牌。
 */
export const BRAND_NAME = '育蒙语音 Agent';

/** 品类词：官网标题、描述里用来解释「这是什么」。 */
export const CATEGORY_NAME = '电话数字员工';

/** 体验热线兜底。展示用分组写法；400 号码拨号不加 +86。 */
export const DEFAULT_HOTLINE = { display: '400-168-8703', href: 'tel:4001688703' } as const;
